import logo from './logo.svg';
import './App.css';
import Map from './Map.tsx';
import data from './data.tsx';
import Info from './Info.tsx'

function App() {
  let infoOpen = true;

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Baltimore City Public Transit Access to University of Maryland Medical Center 🚌
        </p>
      </header>
      <body>
      <Map data={data} width={1500} height={800}/>
      </body>
      <Info/>
      <img class="flag" src='https://www.flagcolorcodes.com/data/Flag-of-Maryland.png'></img>
      <img class="umd" src='https://i.pinimg.com/originals/0a/93/c6/0a93c69ba87efdbbc8b67624a3e2e619.png'></img>
    </div>
  );
}

export default App;
